import React, { useState } from 'react';
import useLocale from 'src/hooks/useLocale';
import { type Device } from '../types/device.types';
import { getMapLink } from '../utils/helperFunctions';
import './Map.sass';
interface AlarmMapProps {
  location: Device;
}

// Component
const AlarmMap: React.FC<AlarmMapProps> = (props) => {
  /* Destructure props*/
  const { location } = props;

  const locale = useLocale();
  // State
  const [showMap] = useState(false);

  /* If location is falsy, then simply render an empty div */
  if (!location || !location.location) {
    return <div />;
  }

  /* Retrieve the map link and latitude and longitude */

  const mapsLink = getMapLink(location.address);
  const { lat, lng } = location.location;

  return (
    <div className="entry">
      <div className="address-title">
        <label data-testid="details-address-label">{locale.spa.address}</label>
      </div>
      <span>
        <a
          href={mapsLink}
          className="link"
          target="_blank"
          rel="noopener noreferrer"
          data-testid="maps-link"
        >
          {location.address}
        </a>
      </span>

      {showMap && (
        <div className="map-wrap">
          <a href={mapsLink} target="_blank" rel="noopener noreferrer">
            <img
              alt="map"
              className="image"
              src={`https://maps.googleapis.com/maps/api/staticmap?center=${lat},${lng}&zoom=15&size=500x250&scale=2&maptype=roadmap&markers=color:red%7Clabel%7C${lat},${lng}&key=API_KEY`}
            />
          </a>
        </div>
      )}
    </div>
  );
};

export default AlarmMap;
